// Export the reducer from this file, to make it consistent with other reducers
export { reducer } from '../../routing'

export const REDUCER_KEY = 'location'



// WEBPACK FOOTER //
// ./src/redux/location/reducer.js